import { Link } from 'react-router-dom';
import { Alert, Space } from 'antd';
import { useTransferStatus } from '../../../../../../Hooks/TT_ELD/CompanyTransfer';
import { TransferBadge, transferSummary } from './transferLabels';
import { COMPANY_TRANSFER_ROLES } from './CompanyTransfer';

interface Props {
  companyId: string;
  company: any;
  role: string;
}

// Shown on the company page while the company is transferring or after it has transferred out
const TransferLockBanner = ({ companyId, company, role }: Props) => {
  const { data: transfer } = useTransferStatus(companyId);
  const transferringOut = company?.eldStatus === 'migrating';
  const summary =
    transfer && transfer.direction === 'out' ? transferSummary(transfer) : company?.eldStatusDescription;

  return (
    <Alert
      type={transferringOut ? 'info' : 'warning'}
      showIcon
      style={{ marginBottom: 12 }}
      message={
        <Space wrap>
          <TransferBadge eldStatus={company?.eldStatus} />
          <span>
            {transferringOut
              ? 'This company is being transferred to another ELD. It is read-only until the transfer finishes.'
              : 'This company was transferred to another ELD. It is read-only here.'}
          </span>
        </Space>
      }
      description={
        <Space direction="vertical" size={2}>
          {summary && <span>{summary}</span>}
          {COMPANY_TRANSFER_ROLES.includes(role) && (
            <Link to={`/sales/company-transfer?companyId=${companyId}`}>View transfer details</Link>
          )}
        </Space>
      }
    />
  );
};

export default TransferLockBanner;
